import { Route } from "react-router-dom";

import "./styles/index.scss";

import Users from "./users/Users";
import UserInfo from "./users/UserInfo";
import UserNew from "./users/UserNew";
import AdminShell from "./AdminShell";
import BlobStorageItems from "./BlobStorageItems";
import BackgroundJobs from "./BackgroundJobs";
import Audit from "./Audit";
import Dashboards from "./dashboards/Dashboards";
import DashboardEdit from "./dashboards/DashboardEdit";
import Events from "./Events";
import Datasources from "./datasources/Datasources";
import DatasourceNew from "./datasources/DatasourceNew";
import ManufacturingAdmin from "./ManufacturingAdmin";
import MyApps from "./MyApps";
import Statistics from "./stats/Statistics";

export const getRoutes = ({ match: { url } }: { match: { url: string } }) => (
    <>
        <Route path={url} component={Statistics} exact />
        <Route path={`${url}/users`} component={Users} />
        <Route path={`${url}/user_info/:user_uuid`} component={UserInfo} />
        <Route path={`${url}/user_new`} component={UserNew} />
        <Route path={`${url}/admin_shell`} component={AdminShell} />
        <Route path={`${url}/blob_storage_items`} component={BlobStorageItems} />
        <Route path={`${url}/background_jobs`} component={BackgroundJobs} />
        <Route path={`${url}/audit`} component={Audit} />
        <Route path={`${url}/dashboards`} component={Dashboards} />
        <Route path={`${url}/dashboard_new`} component={DashboardEdit} />
        <Route path={`${url}/dashboard_edit/:uuid`} component={DashboardEdit} />
        <Route path={`${url}/events/:event_uuid?`} component={Events} />
        <Route path={`${url}/datasources/:handle?`} component={Datasources} />
        <Route path={`${url}/datasource_new`} component={DatasourceNew} />
        <Route path={`${url}/settings`} component={ManufacturingAdmin} />
        <Route path={`${url}/apps`} component={MyApps} />
    </>
);
